function Footer() {
	return (
		<footer
			role="contentinfo"
			style={{
				display: "flex",
				justifyContent: "space-around",
				padding: "1em",
				background: "#003049",
				maxHeight: "2cm",
				overflow: "clip",
			}}
		>
			<img
				src="/img/faldon/cofinanciado_neg.svg"
				alt="Logo de cofinanciación por la Unión Europea"
				style={{ maxWidth: "20vw" }}
			/>
			<img
				src="/img/faldon/fondos_europeos_neg.svg"
				alt="Logo de financiación por fondos europeos"
				style={{ maxWidth: "20vw" }}
			/>
			<img
				src="/img/faldon/laRioja_neg.svg"
				alt=""
				style={{ maxWidth: "20vw" }}
			/>
			<img
				src="/img/faldon/SRI_logo_neg.svg"
				alt=""
				style={{ maxWidth: "20vw" }}
			/>
		</footer>
	);
}

export default Footer;
